import React, { useState } from 'react';
import { AppBar, Toolbar, Box, Button, IconButton, Menu, MenuItem, Container, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import BrandLogo from '../Brand/BrandLogo';

const NAV = [
  { label: 'Home', to: '/' },
  { label: 'Product', to: '/product' },
  { label: 'Support', to: '/support' },
  { label: 'Partner with us', to: '/partner' },
];

/** Slim top bar for the public marketing / contact pages. */
const PublicHeader = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const go = (to) => { setAnchorEl(null); navigate(to); };

  return (
    <AppBar position="sticky" color="inherit" elevation={0} sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ minHeight: { xs: 56, sm: 64 }, gap: 1 }}>
          <Box component={RouterLink} to="/" sx={{ display: 'inline-flex', textDecoration: 'none', mr: 2 }} aria-label="Excubia home">
            <BrandLogo height={32} />
          </Box>

          <Box component="nav" sx={{ display: { xs: 'none', sm: 'flex' }, gap: 0.5, flexGrow: 1 }}>
            {NAV.map((item) => (
              <Button
                key={item.to}
                component={RouterLink}
                to={item.to}
                color="inherit"
                sx={{ fontWeight: location.pathname === item.to ? 700 : 500, color: location.pathname === item.to ? 'primary.main' : 'text.primary' }}
              >
                {item.label}
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'block', sm: 'none' } }} />

          <Box sx={{ display: { xs: 'none', sm: 'flex' }, gap: 1 }}>
            <Button component={RouterLink} to="/login" color="inherit">Sign in</Button>
            <Button component={RouterLink} to="/register" variant="contained">Get started</Button>
          </Box>

          <IconButton sx={{ display: { xs: 'inline-flex', sm: 'none' } }} aria-label="Open menu" onClick={(e) => setAnchorEl(e.currentTarget)}>
            <MenuIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
            {NAV.map((item) => (
              <MenuItem key={item.to} selected={location.pathname === item.to} onClick={() => go(item.to)}>{item.label}</MenuItem>
            ))}
            <Divider />
            <MenuItem onClick={() => go('/login')}>Sign in</MenuItem>
            <MenuItem onClick={() => go('/register')} sx={{ fontWeight: 700, color: 'primary.main' }}>Get started</MenuItem>
          </Menu>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default PublicHeader;
